
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.807 7.824a.863.863 0 00.635-.287l5.196-5.318a.753.753 0 00.232-.568.805.805 0 00-.806-.813.846.846 0 00-.588.246L6.813 5.876 2.138 1.084a.835.835 0 00-.581-.246.807.807 0 00-.575 1.38l5.196 5.32c.191.19.39.286.629.286z","fill":"#AAB4C0"}})])
          )
        }
      }
    